import { gql } from '@apollo/client';

export const ORDER_WITH_PROMO_TOTAL = gql`
  mutation orderTotal($input: OrderTotalInput!) {
    orderTotal(input: $input) {
      totalPrice
      promoDetails {
        discountAmount
        message
        promoCode
        isPromoValid
        amountType
        products {
          id
          quantity
          title
          image_url
        }
      }
      orderTotal
      currencySymbol
      nonSidesPrice
      nonSidesCount
      nonSidesQuantity
      sidesCount
      sidesPrice
      sidesQuantity
      shippingCost
    }
  }
`;

export const CREATE_SUBSCRIPTION_V2 = gql`
  mutation createSubscriptionV2($input: CreateSubscriptionV2Input!) {
    createSubscriptionV2(input: $input) {
      id
      status
      frequency
      planId
      countryCode
      productIdsQuantity {
        product_id
        quantity
      }
      totalItems
      totalPrice
      currencySymbol
      promoDetails {
        discountAmount
        message
        promoCode
        isPromoValid
        amountType
        products {
          id
          quantity
          title
          image_url
        }
      }
      appliedCuminCredits
      subTotalPrice
      salesTax
      orderTotal
      clientSecret
      shippingAddress {
        first_name
        last_name
        address_line_1
        address_line_2
        city
        state
        zip_code
        country_code
        phone_number
      }
      totalPriceSide
      totalItemsSide
      shippingCost
    }
  }
`;

export const UPDATE_SUBSCRIPTION_V2 = gql`
  mutation updateSubscriptionV2($input: UpdateSubscriptionInputV2!) {
    updateSubscriptionV2(input: $input) {
      id
      status
      frequency
      planId
      countryCode
      productIdsQuantity {
        product_id
        quantity
      }
      totalItems
      totalPrice
      currencySymbol
      promoDetails {
        discountAmount
        message
        promoCode
        isPromoValid
        amountType
        products {
          id
          quantity
          title
          image_url
        }
      }
      appliedCuminCredits
      subTotalPrice
      salesTax
      orderTotal
      clientSecret
      shippingAddress {
        first_name
        last_name
        address_line_1
        address_line_2
        city
        state
        zip_code
        country_code
        phone_number
      }
      totalItemsSide
      totalPriceSide
      shippingCost
    }
  }
`;

export const CREATE_SUBSCRIPTION_CHECKOUT = gql`
  mutation CreateSubscriptionCheckout(
    $input: CreateSubscriptionCheckoutInput!
  ) {
    createSubscriptionCheckout(input: $input) {
      id
      url
    }
  }
`;
